import { getErrorMessage } from 'react-error-boundary'

import { IconButton } from '../../actions/iconButton/IconButton'
import { useTranslate } from '../../hooks/useTranslate'
import { Alert } from '../alert/Alert'

export type ErrorFallbackProps = {
  error: unknown
  resetErrorBoundary: () => void
}

export function ErrorFallback({
  error,
  resetErrorBoundary,
}: ErrorFallbackProps) {
  const translate = useTranslate()

  return (
    <Alert
      severity="error"
      title={translate('error.fallback.message')}
      action={
        <IconButton
          onClick={resetErrorBoundary}
          iconName="ArrowPath"
          className="text-inherit!"
        />
      }
    >
      <pre
        // Conservative styling to avoid breaking layout too much
        className="overflow-auto whitespace-pre-wrap"
      >
        {getErrorMessage(error)}
      </pre>
    </Alert>
  )
}
